'use strict';

module.exports = function getCheckerAt (checker, path, precedingPath = []) {
  if (path.length === 0) {
    return checker;
  }

  if (typeof checker.getCheckerForKey !== 'function') {
    return null;
  }

  const [nextKey, ...remainingPath] = path;

  return getCheckerAt(
    checker.getCheckerForKey(nextKey),
    remainingPath,
    precedingPath.concat([nextKey])
  );
};



// WEBPACK FOOTER //
// ./lib/rlink-shapes/getCheckerAt.js